<template>
  <div
    v-if="!data.IsMenuWithSubmenu"  
  >
    <div
      class="main-menu-important-item"
    >
      <table 
        class="menu-important-item"
        :style="{ 
          '--height': height,
          '--background-image': data.TotemMenuImportantImage ? `url(${data.TotemMenuImportantImage})` : ''
        }"
        @click="handleClick(data)"
      >
        <!-- <tr style="height:70%">
          <td>
          </td>
        </tr> -->
        <tr style="height:70%;vertical-align: bottom">
          <td style="width: 178px;">
            <center>{{ getTranslation(data.Name) }}</center>
          </td>
        </tr>
      </table>
    </div>
    <div class="menu-item-shadow">
    </div>
  </div>
  <v-menu
    v-else-if="items"
      bottom
      origin="center center"
      transition="scale-transition"
    >
      <template v-slot:activator="{ on }">
        <div
          class="main-menu-important-item"
        >
          <table 
            class="menu-important-item"
            :style="{ 
              '--height': height,
              '--background-image': data.TotemMenuImportantImage ? `url(${data.TotemMenuImportantImage})` : ''
            }"
            v-on="on"
          >
            <!-- <tr style="height:70%">
              <td>
              </td>
            </tr> -->
            <tr style="height:70%;vertical-align: bottom">
              <td style="width: 178px;">
                <center>{{ getTranslation(data.Name) }}</center>
              </td>
            </tr>
          </table>
        </div>
        <div class="menu-item-shadow">
        </div>
      </template>

      <v-list>
        <v-list-item
          v-for="(item, i) in items"
          :key="i"
          @click="handleClick(item)"
        >
          <v-list-item-title>{{ getTranslation(item.Name) }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
</template>

<script>
import constants from '@/constants'
import i18n from '@/plugins/i18n'
import utils from '@/services/utils'
export default {
  props: {
    index: {
      type: Number,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    items: null,
  }),
  computed: {
    height() {
      return (constants.totem.mainMenu.height - 28) + 'px'
    },
    locale () {
      return i18n.locale
    }
  },
  mounted() {
    if(this.data.Menus) {
      this.items = this.data.Menus
    }
  },
  methods: {
    getTranslation(value) {      
      return utils.getTranslation(value, this.locale)
    },
    handleClick(value) {
      this.$store.state.app.totemMenuSelected = value
    }
  }
}
</script>

<style>
  .main-menu-important-item {    
    background: linear-gradient(180deg, rgba(0,0,0,.3), transparent);
    border-radius: 10px;
    border: 1px solid white;
    margin: 0 10px 0 10px;
  }
  .menu-important-item {
    background-image: var(--background-image);
    width: 100%;
    height: var(--height);
    background-size: cover;
    cursor: pointer;
    padding-bottom: 10px;
    color: white;
    border-radius: 10px;
  }
  .menu-item-shadow {
    background-color: #00000080;
    border-radius: 0 0 10px 10px;
    height: 8px;
    margin-left: 10%;
    width: 80%;
  }
</style>
